import { useEffect, useState } from 'react'

import { apiUrl, toQuery, useApiRequest } from '../../useApiRequest'

import { Booking, BookingFilter } from '../../../types/booking/booking'
import { SliceResponse } from '../../../types/listing'
import { WidgetDataResult } from '../../../types/widget/widget'

export const useUpcomingBookingsWidget = (): WidgetDataResult<Booking[]> => {
  const { run, error } = useApiRequest()
  const [data, setData] = useState<Booking[] | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    run(({ fetcher }) =>
      fetcher<SliceResponse<Booking>>(
        apiUrl(`/bookings${toQuery({ page: 0, size: 5, filter: BookingFilter.UPCOMING })}`)
      )
    )
      .then(response => {
        if (active) setData(response?.content ?? [])
      })
      .catch(() => {
        // exposed through error
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [run])

  return { data, loading, error }
}
